import utils from '../utils/util';
import { useDealerBusiOrder, usePhoneProtected } from '@auto/dealer-busi-order';
import intendCarApi from '../apis/intendcar.api';
import { clientIdentityService } from '../services/intendedCar.service';
import layerManager from '../services/layer.manager';
import * as layerNames from '../services/layerName';
import advApi from '../apis/adv.api';
import store from '../store';
import eventBus from '@/services/eventBus.service';
export default class SmartIntercept {
  constructor(baseInfo) {
    this.order = null;
    this.baseInfo = baseInfo;
    this.redPacketInfo = null;
    this.clearPhone = null;
  }
  getRandomInt(min, max) {
    this.order.randomNum = Math.floor(Math.random() * (max - min + 1) + min);
  }
  getOrderInfo(postData) {
    const deviceId = utils.getCookie('app_deviceid') || '-1';
    const env = process.env.NODE_ENV !== 'production' ? 'test' : 'prod';
    this.order = useDealerBusiOrder({
      deviceId: deviceId,
      time: 60,
      appId: 'dealer.vr',
      source: 'dealer.vr',
      env: env,
      phoneAndName: {
        phone: postData.phone,
        name: postData.userName,
      },
    });
    this.order.orderData.dealerIds = postData.realDealerId ? [...postData.realDealerId] : [postData.dealerId];
    this.order.orderData.seriesIds = [postData.seriesId];
    // setTimeout(() => {
    this.phoneProtected = usePhoneProtected(this.order.orderData);
    this.clearPhone = this.phoneProtected.clearPhone;
  }
  getPackage(data, callback) {
    const validResult = this.order.valid();
    if (validResult) {
      layerManager.toast({ propsData: { message: validResult.message } }, 2000);
      return;
    }
    const checked = document.querySelector('#protestation1').checked;
    if (!checked) {
      const finallCallback = function () {
        callback();
        layerManager.close(layerNames.INQUOREPOLICY_BOTTOM);
      };
      layerManager.open(layerNames.INQUOREPOLICY_BOTTOM, {
        propsData: {
          cancelText: '不同意',
          okText: '同意并免费领取',
          showCloseIcon: true,
          title: '免费领取',
          onOk: () => {
            this.getRedPacketReceive(data, finallCallback);
          },
          tip: '提交后会有经销商与您联系',
        },
      });
      return;
    }
    this.getRedPacketReceive(data, callback);
  }
  getRedPacketReceive(data, callback) {
    const data2 = {
      orderDealerIds: this.redPacketInfo?.extendField?.orderDealerIds,
      dealerIds: this.redPacketInfo?.dealerIds,
      seriesId: this.redPacketInfo?.extendField?.recommendSeriesId,
      eid: decodeURIComponent(this.redPacketInfo?.extendField?.eid),
      dealerId: this.redPacketInfo?.dealerId,
      smsInfo: {
        smsCode: this.order.orderData.smsCode,
        smsGuid: this.order.orderData.smsGuid,
      },
      matchType: this.redPacketInfo?.matchType,
    };
    const finallyData = { ...data, ...data2 };
    advApi
      .redPacketReceive('exhibitionInquiry', finallyData)
      .then((res) => {
        callback();
        eventBus.$emit('toggleGuide', 'play');
        layerManager.toast({ message: '领取成功！' }, 1000);
      })
      .catch((error) => {
        console.log(error);
        layerManager.toast({ propsData: { message: error.message } }, 2000);
        eventBus.$emit('toggleGuide', 'play');
      });
  }
  getRecommendAdFn(seriesId) {
    let self = this;
    return store
      .dispatch('getBaseInfo')
      .then(function () {
        return clientIdentityService.getClientId();
      })
      .then(function (result) {
        let dealerId = self.baseInfo.dealerId;
        const cityId = self.baseInfo.cityId;
        return intendCarApi.getRecommendAd({
          dealerId,
          seriesId: seriesId,
          advId: 10007,
          ...result,
          orderDealerIds: String(dealerId),
          cityId,
          seriesIds: String(seriesId),
          limit: 1,
        });
      })
      .then(function (data) {
        self.redPacketInfo = data[0];
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
  showRule() {
    setTimeout(() => {
      layerManager.open(layerNames.RED_PACKET_RULE_LAYER, {
        propsData: { rules: this.redPacketInfo.rule },
      });
    }, 300);
  }
  showImgCode() {
    layerManager.open(layerNames.RED_PACKET_IMG_CODE_LAYER, {
      propsData: {
        orderUI: this.order.orderUI,
        refreshImgCode: () => {
          this.order.refreshImgCode();
        },
        confirmImgCode: (imgCode) => {
          this.imageCodeLayerConfirm(imgCode);
        },
        closeImgCode: () => {
          this.imageCodeLayerClose();
        },
      },
    });
  }
  imageCodeLayerConfirm(imgCode) {
    this.order.orderData.imageVCode = imgCode;
    this.order.sendSms().then((sended) => {
      this.order.orderData.imageVCode = '';
      this.order.orderData.smsCode = '';
      if (sended) {
        this.imageCodeLayerClose();
      }
    });
  }
  imageCodeLayerClose() {
    this.order.orderUI.showImageVCode = false;
  }
}
